import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-300">
      <div className="max-w-3xl mx-auto text-center" data-id="element-301">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-302">
          Si sos entrenador o profe de básquet en Argentina,
          <br data-id="element-303" />
          <span className="text-[#F97316]" data-id="element-304">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-305">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-306">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-307">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-308">
              Llegás a la cancha sin saber exactamente qué ejercicio vas a dar
              hoy
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-309">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-310">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-311">
              Tus jugadores más chicos no progresan porque no tenés una
              secuencia clara por nivel
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-312">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-313">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-314">
              El 60% de los chicos abandona antes del año y no sabés cómo
              prevenirlo
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-315">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-316">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-317">
              Cuando llueve o falta el gimnasio cancelás y perdés el ingreso
              porque no tenés un Plan B listo
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-318">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-319">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-320">
              No podés justificar un aumento de precio porque no tenés un
              sistema profesional visible
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-321">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-322">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-323">
              Siempre las mismas correcciones improvisadas, sin un método claro
              que te respalde
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-324">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-325">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-326">
              Tenés jugadores de distintos niveles y categorías juntos y el
              entrenamiento se convierte en un caos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-327">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-328">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-329">
              Fin de mes y no sabés exactamente cuánto vas a cobrar porque la
              comunicación con los padres es un desastre
            </p>
          </div>
        </div>

        <p className="text-[#F97316] text-2xl sm:text-3xl font-black mb-8" data-id="element-330">
          ¿Cuántos entrenamientos más vas a improvisar?
        </p>

        {/* Orange divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#F97316] to-transparent w-full" data-id="element-331" />
      </div>
    </section>;
}